function Footer() {
  return (
    <footer>
      <nav className="navbar navbar-dark">
        <span className="navbar-brand footer-text"> &copy; 2025</span>
      </nav>
    </footer>
  )
}

export default Footer
